var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LabeledIcon',{directives:[{name:"overflow-title",rawName:"v-overflow-title",value:(_vm.text),expression:"text"}],attrs:{"icon":_vm.icon,"label":_vm.text}})}
var staticRenderFns = []

export { render, staticRenderFns }